import React from 'react'
import PropTypes from 'prop-types'
import ArrowLeft from '#components/svg/icons/ArrowLeft'

function KachelListView({
  items,
  itemText,
  handleClick,
  showAllRedirect,
  showAllItemsButtonText,
  testId,
  showMoreButton,
}) {
  function ShowAllButton() {
    return (
      <button
        type="button"
        onClick={() => showAllRedirect()}
        className="kachelListViewShowAllButton"
        data-testid="kachelListViewShowAllButton"
      >
        <span>{showAllItemsButtonText}</span>
        <ArrowLeft />
      </button>
    )
  }

  return (
    <div>
      <div data-testid={testId}>
        {items.map(item => (
          <button
            data-testid="kachelListView-item"
            className="uebersicht__kachelListViewItem"
            type="button"
            onClick={() => handleClick(item)}
            key={item.chapterId ? item.chapterId.toString() + item.azubiId.toString() : item.id}
          >
            {itemText(item)}
            <ArrowLeft />
          </button>
        ))}
      </div>
      {showMoreButton && <ShowAllButton />}
    </div>
  )
}

KachelListView.propTypes = {
  testId: PropTypes.string,
  items: PropTypes.array.isRequired,
  itemText: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  showAllRedirect: PropTypes.func.isRequired,
  showAllItemsButtonText: PropTypes.string.isRequired,
  showMoreButton: PropTypes.bool.isRequired,
}

export default KachelListView
